import { render, staticRenderFns } from "./InputNewPassword.vue?vue&type=template&id=567da332&"
import script from "./InputNewPassword.vue?vue&type=script&lang=ts&"
export * from "./InputNewPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports